<template>
    <div class="animate-pulse">
        <div v-if="type === 'text'" :class="['bg-gray-600 rounded', heightClass]"></div>
        <div v-else-if="type === 'card'" class="bg-gray-700 rounded-2xl p-5">
            <div class="bg-gray-600 h-12 rounded mb-3"></div>
            <div class="bg-gray-600 h-6 rounded w-3/4"></div>
        </div>
        <div v-else-if="type === 'list'" class="space-y-3">
            <div v-for="i in count" :key="i" class="bg-gray-600 rounded" :class="heightClass"></div>
        </div>
        <div v-else class="bg-gray-600 rounded" :class="heightClass"></div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    type: {
        type: String,
        default: 'text',
        validator: (value) => ['text', 'card', 'list', 'custom'].includes(value)
    },
    height: {
        type: String,
        default: 'h-4'
    },
    count: {
        type: Number,
        default: 3
    }
})

const heightClass = computed(() => props.height)
</script>

<style scoped>
@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
